import React, { useState } from 'react'
 
 
import SalesTrainingDetailList from './SalesTrainingDetailList';
import SalesTrainingDetailForm from './SalesTrainingDetailForm';

const SalesTrainingDetail= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <SalesTrainingDetailForm addForm={setFromIsShown} update={upData} />
        ) : (
          <SalesTrainingDetailList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default SalesTrainingDetail